import React, { Component } from 'react';
import { Table, Row, Button, DatePicker, message, Spin, } from 'antd';
import moment from 'moment';
import { dataDefault } from './data';
import imgSave from "../../../saveImg";
import Auth from "../../../Auth";
import TableText from "../../../TableText";
import { getJson, Num, calculation } from '../../../../../method';
import ExportExcel from "@/method/components/ExportExcel"
const { MonthPicker } = DatePicker;


class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            note: { note: "" },
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getData(this.state.date);
    }

    computeNum = (data) => {

        data.forEach((v, i) => {
            data[i].price = calculation(v.total_sales, v.qty);
            data[i].total_cost = (v.qty * v.cost).toFixed(2);
            data[i].percent = calculation(v.total_cost, v.total_sales, 4);
        });

        this.setState({
            data
        });

    }

    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    // 获取表格5_6_1内容
    getData = (date) => {
        fetch(
            `/_5_8_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`,
            { credentials: 'include' }
        ).then(x => x.json()).then(
            x => {
                let data = JSON.parse(JSON.stringify(dataDefault));
                const d = getJson(['data', 'data'], x, []);
                if (d.length > 0) data = d;

                this.computeNum(data);
                this.setState({ loading: false });
            }
        ).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        })
    }
    // 保存表格5-6-1内容
    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_5_8_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_6_1', 1.5, '5.81', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const { data, date, print } = this.state;
        const columns = [{
            title: "Food Items 食品项目",
            children: [{
                title: "NO.",
                dataIndex: 'sort',
                key: 'sort',
                align: "center",
                width: 50,
                render: text => {
                    return (text + 1)
                }
            }, {
                title: "Description 描述",
                dataIndex: 'des',
                key: 'des',
                align: "center",
                width: 300,
                render: (text, record, index) => {
                    if (print) return text;
                    const props = {
                        text, index, type: 'input', name: "des", onChange: this.onChange,
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: "Qty 数量",
                dataIndex: 'qty',
                key: 'qty',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (print) return text;
                    const props = {
                        text, index, type: 'inputNumber', name: "qty", onChange: this.onChange,
                        compared: {
                            title: ["Qty 数量"],
                            record,
                            sqlName: "_5_8_1"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: "Unit cost 单位成本",
                dataIndex: 'cost',
                key: 'cost',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (print) return text;
                    const props = {
                        text, index, type: 'inputNumber', name: "cost", onChange: this.onChange,
                        compared: {
                            title: ["Unit cost 单位成本"],
                            record,
                            sqlName: "_5_8_1"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: "Unit Price 单价",
                dataIndex: 'price',
                key: 'price',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (print) return text;
                    const props = {
                        text, index, type: 'number', name: "price", onChange: this.onChange,
                        compared: {
                            title: ["Unit Price 单价"],
                            record,
                            sqlName: "_5_8_1"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: "Total cost 总成本",
                dataIndex: 'total_cost',
                key: 'total_cost',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (print) return text;
                    const props = {
                        text, index, type: 'number', name: "total_cost", onChange: this.onChange,
                        compared: {
                            title: ["Total cost 总成本"],
                            record,
                            sqlName: "_5_8_1"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: "Total sales 销售总额",
                dataIndex: 'total_sales',
                key: 'total_sales',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (print) return text;
                    const props = {
                        text, index, type: 'inputNumber', name: "total_sales", onChange: this.onChange,
                        compared: {
                            title: ["Total sales 销售总额"],
                            record,
                            sqlName: "_5_8_1"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: "Cost% 成本百分比",
                dataIndex: 'percent',
                key: 'percent',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    if (print) return text;
                    const props = {
                        text, index, type: 'percent', name: "percent", onChange: this.onChange,
                        compared: {
                            title: ["Cost% 成本百分比"],
                            record,
                            sqlName: "_5_8_1"
                        }
                    };
                    return <TableText data={{ ...props }} />
                }
            }]
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title " id="table5_6_1"  >
                        <Row>5.8.1  Top 10 Favorite 十大受欢迎菜品  </Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                        note: { note: "" }
                                    });
                                    this.getData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="export5_8_1"
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>

                    <Row className="table-footer-btn">
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {

                                this.setState({ print: true, loading: true }, () => {
                                    ExportExcel({
                                        id: "export5_8_1",
                                        date,
                                        name: "5.8.1 Top 10 Favorite 十大受欢迎菜品"
                                    });
                                    this.setState({ print: false, loading: false });
                                });

                            }}
                            loading={this.state.print}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_5_8">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-8/5-8-1/index.js